import { useCallback } from "react";
import useSendDataToGTM from "@features/analytics/hooks/useSendDataToGTM";
import { getGaDataObject } from "@features/pulse/utils/helpers";
import { SanitizedPulseData } from "@features/pulse/utils/types";

/**
 * This hook is used to send Google Analytics data for Pulse articles.
 * It provides functions to send tracking data and custom events to Google Tag Manager.
 */
export default function useSendPulseGaData() {
  const sendDataToGTM = useSendDataToGTM();

  const sendTrackingData = useCallback(
    (
      title: string,
      virtualUrl: string,
      articleId?: string,
      articles?: SanitizedPulseData[],
      pagination?: string
    ) => {
      const gaDataObject = getGaDataObject(
        title,
        virtualUrl,
        articleId,
        articles,
        pagination
      );
      sendDataToGTM(gaDataObject);
    },
    [sendDataToGTM]
  );

  const sendCustomEvent = useCallback(
    (eventAction: string, eventLabel: string) => {
      const trackingData = {
        event: "custom_event",
        eventCategory: "bt pulse",
        eventAction,
        eventLabel,
      };

      sendDataToGTM(trackingData);
    },

    [sendDataToGTM]
  );

  return { sendTrackingData, sendCustomEvent };
}
